import type { ReactNode } from "react";

import { Spread } from "@/design-system/Spread";

interface ListPageToolbarProps {
  search: ReactNode;
  filters?: ReactNode;
  actions?: ReactNode;
}

/** Search, filters, and trailing secondary actions for ticket-list headers. */
export function ListPageToolbar({ actions, filters, search }: ListPageToolbarProps): ReactNode {
  return (
    <Spread space="sm">
      <div className="flex min-w-0 flex-1 items-center gap-space-sm">
        <div className="w-full max-w-search-wide">{search}</div>
        {filters}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap gap-space-sm">{actions}</div>}
    </Spread>
  );
}
